import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const organizationfilterApi = createApi({
  reducerPath: "organizationfilterApi",
  baseQuery,
  tagTypes: ["Organization"], // ✅ required if using providesTags or invalidatesTags
  endpoints: (builder) => ({
    // Optional: if you want a mutation to apply filters (rare for GET)
    applyorganizationFilter: builder.mutation({
      query: (filters) => {
        const body = filters;
    
        return {
          url: apiurl.Import_filter,
          method: "POST",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: body,
        };
      },
      invalidatesTags: ["Organization"], // ✅ make sure this is defined
    }),
  }),
});

// Export hooks for usage in components
export const {
  useApplyorganizationFilterMutation,
} = organizationfilterApi;
